module.exports = __webpack_public_path__ + "images/emoji/name_badge.26726b31af39ddaf90fc.png";